import React, { useEffect, useState } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import { VariableSuppliers } from './VariableSuppliers';
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom';
import { loadSupplierss } from '../../../../store/Actions/ActionSuppliers';
import { loadProducts } from '../../../../store/Actions/ActionProducts';
import { loadProjects } from '../../../../store/Actions/ActionProjects';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';
import SelectDropDown from '../../../../components/elements/SelectDropDown';
import TextAreaCustom from '../../../../components/elements/TextAreaCustom';
import InputCustom from '../../../../components/elements/InputCustom';
import { putSupply } from '../../../../store/Actions/ActionSupply';

function EditProductSupplier({ open, setOpen, arr }) {
    const { dispatch, langLocal, navigate, mode } = AbstructVar()
    const { state, setStateCustom, setLoad, setState } = VariableSuppliers()
    const { translate } = AbstructLang()
    const { projects, loadingProjects, products, loadingProducts, suppplierss, loadingSuppplierss } = useSelectorCustom()
    const [arrProjects, setArrProjects] = useState([])
    const [arrProducts, setArrProducts] = useState([])
    const [arrSuppplierss, setArrSuppplierss] = useState([])
    const [fields1, setFields1] = useState([{ file_path: '', notes: '' }])
    useEffect(() => {
        const extractTime = (dateTimeString) => {
            if (!dateTimeString) return '';
            const timePart = dateTimeString.split('T')[1];
            return timePart.split('.')[0];
        };
        setState((prevState) => ({
            ...prevState,
            material_id: arr.material?.id,
            material_name: arr.material?.name,
            company_project_id: arr.company_project?.id,
            company_project_name: arr.company_project?.name,
            supplier_id: arr.supplier?.id,
            supplier_name: arr.supplier?.first_name + ' ' + arr.supplier?.last_name,
            qty: arr?.qty,
            cost: arr?.cost,
            currency: arr?.currency,
            date_of_supply: arr?.date_of_supply?.split('T')[0],
            time_of_supply: extractTime(arr?.time_of_supply),
            place_of_supply: arr?.place_of_supply,
            reason_of_supply: arr?.reason_of_supply,
        }));
    }, [arr]);
    useEffect(() => {
        dispatch(loadSupplierss())
        dispatch(loadProducts())
        dispatch(loadProjects())
    }, []);
    useEffect(() => {
        setArrProjects(projects?.map((project) => ({
            value: project?.id,
            label: project?.name
        })))
    }, [projects])
    useEffect(() => {
        setArrProducts(products?.map((product) => ({
            value: product?.id,
            label: product?.name
        })))
    }, [products])
    useEffect(() => {
        setArrSuppplierss(suppplierss?.map((suppplier) => ({
            value: suppplier?.id,
            label: suppplier?.first_name + ' ' + suppplier?.last_name
        })))
    }, [suppplierss])
    const handleFieldChange = (index, field, value) => {
        const newFields = [...fields1]
        newFields[index][field] = value
        setFields1(newFields)
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(putSupply(arr?.id, state, setLoad));
    };
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `pop_center_edit_product ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className='edit-product' >
                <div className='inner-main' >
                    <h3>{translate('edit_supply')}</h3>
                    <div >
                        <div className='d-flex' >
                            <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select`} >
                                <span>{translate('materials')}</span>
                                <SelectDropDown
                                    options={arrProducts}
                                    varr={state?.material_id}
                                    setVarr={(value) => setStateCustom('material_id', value)}
                                    loadingList={loadingProducts}
                                    defaultvalue={{ value: state.material_id, label: state.material_name }}
                                />
                            </div>
                            <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select`} >
                                <span>{translate('projects')}</span>
                                <SelectDropDown
                                    options={arrProjects}
                                    varr={state?.company_project_id}
                                    setVarr={(value) => setStateCustom('company_project_id', value)}
                                    loadingList={loadingProjects}
                                    defaultvalue={{ value: state.company_project_id, label: state.company_project_name }}
                                />
                            </div>
                            <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select`} >
                                <span>{translate('supplier')}</span>
                                <SelectDropDown
                                    options={arrSuppplierss}
                                    varr={state?.supplier_id}
                                    setVarr={(value) => setStateCustom('supplier_id', value)}
                                    loadingList={loadingSuppplierss}
                                    defaultvalue={{ value: state.supplier_id, label: state.supplier_name }}
                                />
                            </div>
                        </div>
                    </div>
                    <div /*className='supplier-add'*/ >
                        <div className='d-flex' >
                            <div style={{ width: '31.8%' }} >
                                <InputCustom
                                    label='qty'
                                    iconType='pencil'
                                    type='number'
                                    value1={state.qty}
                                    onChange={(e) => setStateCustom('qty', e.target.value)}
                                />
                            </div>
                            <div style={{ width: '31.8%' }} >
                                <InputCustom
                                    label='cost'
                                    iconType='pencil'
                                    type='number'
                                    value1={state.cost}
                                    onChange={(e) => setStateCustom('cost', e.target.value)}
                                />
                            </div>
                            <div className='one-select' >
                                <span>{translate('currency')}</span>
                                <SelectDropDown
                                    options={[{ value: 'dollar', label: "Dollar" }, { value: 'syrian_bound', label: "Syrian Bound" }]}
                                    varr={state?.currency}
                                    setVarr={(value) => setStateCustom('currency', value)}
                                    defaultvalue={{ value: state.currency, label: state.currency }}
                                />
                            </div>

                            <div className='w-30' >
                                <InputCustom
                                    label='date'
                                    iconType='pencil'
                                    type='date'
                                    value1={state.date_of_supply}
                                    onChange={(e) => setStateCustom('date_of_supply', e.target.value)}
                                />
                            </div>
                            <div className='w-30' >
                                <InputCustom
                                    label='time'
                                    iconType='pencil'
                                    type='time'
                                    value1={state.time_of_supply}
                                    onChange={(e) => setStateCustom('time_of_supply', e.target.value)}
                                />
                            </div>
                            <div style={{ width: '31.8%' }} >
                                <InputCustom
                                    label='place'
                                    iconType='pencil'
                                    type='text'
                                    value1={state.place_of_supply}
                                    onChange={(e) => setStateCustom('place_of_supply', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className='d-flex' style={{ marginTop: '-10px' }} >
                            <div style={{ width: '555px' }} >
                                <TextAreaCustom
                                    label='reason'
                                    value={state.reason_of_supply}
                                    onChange={(e) => setStateCustom('reason_of_supply', e.target.value)}
                                    nameClass='textarea-general'
                                />
                            </div>
                        </div>
                    </div><br></br>
                    <button className='btn_top_table' onClick={handleSubmit} >
                        {
                            state?.Load ? "Loading ..." : translate('edit')
                        }
                    </button>
                </div>
            </div>
        </RModal>
    )
}

export default EditProductSupplier